module.exports = __webpack_public_path__ + "static/img/pt.d729721.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt.svg
// module id = By/3
// module chunks = 4